import React, { Component } from 'react';
// import PageHeader from "../../../hoc/PageHeader";
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state ={
            isModalOpen:this.props.isModalOpen,
            fade:this.props.isModalOpen,
            buttonList:this.props.buttonList
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.isModalOpen !== this.props.isModalOpen || prevProps.buttonList !== this.props.buttonList) {
          this.setState({isModalOpen: this.props.isModalOpen, buttonList:this.props.buttonList});
          setTimeout(() => {
            this.setState({fade: this.props.isModalOpen});
          }, 100);
        }
        
    }
    render () {
        const {contentStyle,headerButtonList} = this.props;
        const Title = this.props.title;
        const buttonList = this.state.buttonList;
        const modalBody = this.props.modalBody;
        const isShowModalCss = (this.state.isModalOpen) ? "block":"none";
        const isShowModal = (this.state.fade) ? "show":"hide";
        const maxWidth = (this.props.maxWidth)? this.props.maxWidth:"";
        const modalDim = (this.props.modalDim)? this.props.modalDim:"modal-xl";
        const attributes = (this.props.attributes)?this.props.attributes:{};
        const zIndex = (this.props.zIndex)? this.props.zIndex:"1043";
        
        //style={(this.props.style)?this.props.style:""}
        return (
            
                <div style={{display:isShowModalCss}}>
                <div  className={["modal","fade",isShowModal].join(" ")}  {...attributes} tabIndex="-1" role="dialog" aria-labelledby="staticModalLabel" style={{display:'block',zIndex: (Number(zIndex)+7)}}  aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div  className={["modal-dialog",modalDim].join(" ")}  role="document">
                    <div className="modal-content" style={{...contentStyle}}>
                        {(Title!==false)?
                            <ModalHeader Title={Title} titleClass ={this.props.titleClass} headerButtonList={headerButtonList}/>
                        :''}
                        <ModalBody 
                            {...this.props}
                            modalBody={modalBody}
                        />
                         {(buttonList.length>0)?
                            <ModalFooter buttonList={buttonList} />
                        :''}
                        
                        

                    </div>
                </div>
            </div>
            <div className={["modal-backdrop","fade",isShowModal].join(" ")} style={{zIndex: zIndex}}></div> 
             </div>
            
            
            
            
        )
    }
}

Modal.defaultProps = {
    contentStyle:{
        
    },
    headerButtonList:[],
    titleClass: '',
}
export default Modal;


